<topo-modal [isActive]="showPage === true" [width]="600">
  <div
    fxLayout="column"
    fxLayoutAlign="space-around center"
    style="padding: 30px">
    <div class="icon-back">
      <div style="position: relative; left: 20px; top: 20px">
        <i
          class="icon"
          [ngClass]="icon"
          style="font-size: 50px"></i>
      </div>
    </div>
    <div
      class="is-size-3"
      style="padding-top: 25px">
      <h5>{{ 'LOGIN.BU-WARNING-TITLE' | translate }}</h5>
    </div>
    <div
      class="is-size-6"
      style="padding-top: 25px; width: 400px"
      [ngStyle]="{ 'text-align': messageAlign }"
      innerHTML="{{ 'LOGIN.BU-WARNING-MESSAGE' | translate }}">
    </div>
    <div
      style="padding-top: 65px; padding-bottom: 25px"
      fxLayout="row">
      <button
        class="button is-medium is-primary"
        style="width: 150px"
        (click)="okClick()">
        {{ 'LOGIN.OK' | translate }}
      </button>
    </div>
  </div>
</topo-modal>
